<template>
  <header>
    <!-- We want header content here -->
    <b-row
      class="border-bottom px-pad justify-content-center align-items-center"
      style="height:42px;"
    >
      <b-col cols="6" class="px-0">
        <h2 class="page-title text-truncate mb-2">{{ title }}</h2>
      </b-col>
      <b-col cols="6" class="text-right px-0">
        <!-- <a @click="$router.go(-1)">
          <i class="la la-remove la-lg text-decoration-none mb-2"></i>
        </a> -->
        <span class="cursor_pointer" @click="$emit('redirectPage')">
          <i class="la la-remove la-lg text-decoration-none mb-2"></i>
        </span>
      </b-col>
    </b-row>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: ["title"]
};
</script>

<style scoped>
.page-title {
  margin-bottom: 14px;
  font-size: 21px;
  margin-top: 0px;
}
</style>
